// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-cursor{position:fixed;width:4rem;height:4rem;border-radius:50%;pointer-events:none;z-index:5;transform:translate(-50%,-50%)}.custom-cursor__circle-wrapper{position:absolute;top:50%;left:50%;width:100%;height:100%;transform:translate(-50%,-50%)}.custom-cursor__circle-wrapper__circle{width:100%;height:100%;border:1px solid #fff;border-radius:50%}", ""]);
// Exports
module.exports = exports;
